import React, { useEffect, useState } from "react";
import { Stepper } from "react-form-stepper";
import {
  AddressDetailsForm,
  PersonalDetailsForm,
  BankDetailsForm,
  WorkDetailsForm,
} from "./EmployeeForm";
import useRead from "../../hooks/useRead";
import Spinner from "../../components/loader/Spinner";
import EmployeeProvider from "../../providers/EmployeeProvider";
import toast from "react-hot-toast";
import { useParams } from "react-router-dom";
import useGet from "../../hooks/read/useGet";
import EditEmployeeProvider from "../../providers/EditEmployeeProvider";
import BreadCrumbs from "../../components/ui/BreadCrumbs";
function EditEmployee() {
    
    const [editData,setEditData] = useState({})
    const breadcrumbs = [
        { label: "Employee", link: "/employee-details" },
        { label: "Edit Employee", link: "" },
      ];
    const { company_employee_id, username } = useParams() 
    const { list  } = useGet({
        url: 'employeedetails_edit',
        initialData: { company_employee_id },
        onSuccess: (res) => {
            setEditData(res?.data)
        },
        onError:(err) => {
            const {status,data} = err.response || {}
            if(status >= 400 || status <=499){
                toast.error(data.message)
            }else{
                toast.error('Internal Server Error')
            }
        }
    })
  const [step, setStep] = useState(0);
  const handleNextStep = () => {
    setStep((prev) => prev + 1);
  };
  const handlePrevStep = () => {
    setStep((prev) => prev - 1);
  };
  const { list: employmentList } = useRead({
    url: "employment_listing",
    initialData: {
      limit: 50,
      search_query: "",
    },
  });
  const { list: shiftList } = useRead({
    url: "shift_listing",
    method:'GET',
    initialData: {
      limit: 50,
      search_query: "",
    },
  });

  const { list: departmentListing } = useRead({
    url: "department_listing",
    method:'GET',
    initialData: {
      limit: 50,
      search_query: "",
    },
  });

  return (
    <EditEmployeeProvider initialValue={editData}>
      {(employmentList.isLoading || shiftList.isLoading || departmentListing.isLoading) && <Spinner />}
      <div className="px-5">
        <BreadCrumbs crumbs={breadcrumbs} />
        <Stepper
          steps={[
            { label: "Personal Details" },
            { label: "Address Details" },
            { label: "Work Details" },
            { label: "Bank Details" },
          ]}
          activeStep={step}
        />
        <div className="py-10">
          {step === 0 && (
            <>
              <PersonalDetailsForm   onNextStep={handleNextStep}
                // prefilledData={employeeDetails}
              />
              
            </>
          )}
          {step === 1 && (
            <AddressDetailsForm
              onNextStep={handleNextStep}
              onPreviousStep={handlePrevStep}
            />
          )}
          {step === 2 && (
            <WorkDetailsForm
              onNextStep={handleNextStep}
              onPreviousStep={handlePrevStep}
              employmentList={employmentList.data?.data || []}
              shiftList={shiftList.data?.data || []}
              departmentListing={departmentListing?.data?.data || []}
            />
          )}
          {step === 3 && (
            <BankDetailsForm
              onNextStep={handleNextStep}
              onPreviousStep={handlePrevStep}
            />
          )}
        </div>
      </div>
    </EditEmployeeProvider>
  );
}

export default EditEmployee;
